var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FormErrorController from '../FormErrorController';
import EventTracker from '../../EventTracker';
export default class FormRequestController {
    constructor(formComplex) {
        this.formComplex = formComplex;
        this.form = formComplex.form;
        this.form.noValidate = true;
        this.form.addEventListener('submit', (e) => this.onFormSubmit(e));
    }
    onFormSubmit(e) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            const nativeValidityChecksPassed = this.form.reportValidity();
            for (const feature of this.formComplex.features) {
                try {
                    if (!feature.onSubmit)
                        continue;
                    const error = yield feature.onSubmit(e);
                    if (error) {
                        const errorMessage = 'SchulgeldErmaessigung: onSubmit failed';
                        console.error(errorMessage, error);
                    }
                }
                catch (e) {
                    console.error('SchulgeldErmaessigung: Feature failed to run onSubmit', e);
                    EventTracker.track('exception', 'SchulgeldErmaessigung: Feature failed to run onSubmit' + e);
                }
            }
            if (FormErrorController.hasErrors() || !nativeValidityChecksPassed) {
                for (const feature of this.formComplex.features) {
                    (_a = feature.onSubmitFailed) === null || _a === void 0 ? void 0 : _a.call(feature);
                }
                EventTracker.track('submit-validation-fail', 'form was submitted, but not all fields where valid');
                return;
            }
            const formData = new FormData(this.form);
            const response = yield fetch(this.form.action, {
                method: this.form.method,
                body: formData,
            });
            EventTracker.track('submit', 'form was submitted');
            const html = yield response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const errors = [];
            for (const feature of this.formComplex.features) {
                try {
                    if (feature.onServerResponse) {
                        errors.push(yield feature.onServerResponse(doc));
                    }
                }
                catch (e) {
                    console.error('FormRequestController: Feature failed to run onServerResponse', e);
                    EventTracker.track('exception', 'FormRequestController:Feature failed to run onServerResponse' + e);
                }
            }
            if (errors.some((error) => error)) {
                const submitButton = this.form.querySelector('button[type="submit"]');
                const textNode = submitButton.childNodes.item(0);
                if (textNode) {
                    textNode.textContent = 'Absenden';
                }
                else {
                    submitButton.textContent = 'Absenden';
                }
                submitButton.disabled = false;
            }
            else {
                document.body.innerHTML = doc.body.innerHTML;
            }
        });
    }
}
